export default "__VITE_ASSET__DX30u0m3__"